<template>

    <p class="paragraph text-base" :class="{ '--no-margin': noMargin, '--heading': heading, '--inner-space': innerSpace }">
        <slot/>
    </p>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'Paragraph',
        props: {
            heading: { type: Boolean, default: false },
            noMargin: { type: Boolean, default: false },
            innerSpace: { type: Boolean, default: true }
        }
    })

</script>

<style lang="scss">

    @include component(paragraph) {

        ul {

            li {

                @apply relative pl-6;

                &:before {

                    position: absolute;
                    top: 11px;
                    left: 0px;
                    width: 6px;
                    height: 6px;
                    background: #666666;
                    border-radius: 50%;
                    content: '';

                }

            }

        }

        + #{component(paragraph)} {

            @apply inline mt-6;

        }

        @include option(no-margin) {

            + #{component(paragraph)} {

                @apply mt-0;

            }

        }

        @include option(heading) {

            @apply pl-6 leading-6 font-mabry-pro font-bold;

            font-size: 20px;
            border-left: 1px solid #cccccc;

        }

        @include option(inner-space) {

            p:not(:first-child) {

                padding-top: 32px;

            }

        }

    }

</style>
